<script setup lang="ts">
import PrimeDrawer from 'primevue/drawer'

export type DrawerPosition = 'left' | 'right' | 'top' | 'bottom' | 'full'

interface Props {
  modelValue: boolean
  position?: DrawerPosition
  header?: string
  /** Panel width (any CSS length). Default `'520px'`. */
  width?: string
  /** Tap-outside dismisses the drawer. Default `true`. */
  dismissable?: boolean
  /** Show the X close icon in the header. Default `true`. */
  showCloseIcon?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  position: 'right',
  width: '520px',
  dismissable: true,
  showCloseIcon: true,
})

const emit = defineEmits<{
  (e: 'update:modelValue', value: boolean): void
  (e: 'hide'): void
}>()

const pt = {
  root: {
    class: 'app-drawer__panel',
    style: { width: props.width, maxWidth: '100vw' },
  },
  header: { class: 'app-drawer__header' },
  content: { class: 'app-drawer__content' },
}

const onHide = () => {
  emit('update:modelValue', false)
  emit('hide')
}
</script>

<template>
  <PrimeDrawer
    :visible="modelValue"
    :position="position"
    :header="header"
    :dismissable="dismissable"
    :showCloseIcon="showCloseIcon"
    :pt="pt"
    :block-scroll="true"
    @update:visible="(v: boolean) => !v && onHide()"
  >
    <template v-if="$slots.header" #header>
      <slot name="header" />
    </template>
    <slot />
  </PrimeDrawer>
</template>
